import { Component } from '@angular/core';

@Component({
  selector: 'uni-form-field-error',
  templateUrl: './uni-form-field-error.component.html',
  styleUrls: ['./uni-form-field-error.component.scss']
})
export class UniFormFieldErrorComponent { }
